<template>
  <app-header/>
  <div id="all">
    <main id="main">
      <div class="container">
        <div class="booling-box" v-if="isCustomer">
          <ul class="tabs-list events">
            <li class="tab-link" :class="!current ? 'current' : ''" data-tab="tab-5" @click="setCurrent(0)">My LX Events</li>
            <li class="tab-link" :class="current ? 'current' : ''" data-tab="tab-6" @click="setCurrent(1)">Past Events</li>
          </ul>

          <div class="title-wrapper title-sort-wrapper">
            <h1 class="title line">My LX Events</h1>
            <div class="sort-wrapper">
              <div class="sort-box">
                <span>Sort by:</span>
                <p class="item" :class="openSort ? 'active' : ''" @click="openSort = !openSort">
                  <span>{{sortParam}}</span>
                  <icon-base width="11" height="7" viewBox="0 0 11 7"><icon-arrow-down/></icon-base>
                </p>
              </div>
            </div>
            <div class="buttons-box">
              <a href="#" class="btn success" @click.prevent="addEventClick">
                <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-plus color="white"/></icon-base>
                <span>ADD NEW</span>
              </a>
            </div>
          </div>


          <events-list :events="events" :btn-col="true" :current="!current" :open-sort="openSort" @setSort="setSort" v-if="events.length"></events-list>
          <div v-if="!events.length" id="tab-5" class="tab-content current my-events-box" >
            <div class="message-no-events">
              <p class="message">There are no upcoming events.</p>
              <p>Click the “<a href="#" @click.prevent="addEventClick">Add New</a>” button to create an event</p>
            </div>
          </div>

          <h2 class="title line event-title">Past Events</h2>

          <events-list :events="pastEvents" :current="current" :open-sort="openSort" @setSort="setSort" :active="0" v-if="pastEvents.length"></events-list>

          <div v-if="!pastEvents.length" id="tab-6" class="tab-content past-events-box">
            <div class="message-no-events">
              <p class="message">There are no past events.</p>
            </div>
          </div>

        </div>
        <div v-else>
          <div class="message-no-events">
            <h1 class="title line">You are not a customer</h1>
            <p>Go to  <a href="/admin" >Admin Panel</a></p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import EventsList from "./EventsList"
import AddEvent from "./Client/AddEvent"
import AppHeader from "./AppHeader";
import IconBase from "./common/IconBase";
import IconPlus from "./common/icons/IconPlus";
import IconArrowDown from "./common/icons/IconArrowDonw";

export default {
    name: 'ClientApp',
    components: {IconArrowDown, IconPlus, IconBase, AppHeader, EventsList},
    computed: {
        ...mapState('events', [
            'events',
            'pastEvents',
        ]),
        ...mapState('user', [
            'roles'
        ]),
    },
    data() {
        return {
            isCustomer: true,
            current: 0,
            openSort: false,
            sortParam: 'Status',
        }
    },
    created() {
        this.getUserInfo().then(() => {
            if (this.roles.includes('manager') || this.roles.includes('dev')){
                this.$router.push('/manage/requests')
            }
            if (this.roles.includes('admin') || this.roles.includes('admin')){
                this.isCustomer = false
            }
            this.loadEvents();
        });
    },
    mounted() {
        //this.loadEvents();
    },
    methods: {
        ...mapMutations([
            'setLoading',
            'switchPopup',
            'setPopupComponent',
            'setPopupData'
        ]),
        ...mapActions('events', [
            'loadEvents'
        ]),
        ...mapActions('user', [
            'getUserInfo',
        ]),
        addEventClick() {
            this.setPopupComponent(AddEvent);
            this.setPopupData({id: 44});
            this.switchPopup(true);
        },
        setCurrent(index) {
            this.current = index;
        },
        setSort(value) {
            this.openSort = false;
            this.sortParam = value;
        }
    },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
